import "../../../../content/blog/2018-04-23-m&ms-retrospective.css";
import React from 'react';
export default {
  React
};